var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_5754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50277 15.9982H7.50123C7.46196 15.9868 7.42194 15.9783 7.38146 15.9727C6.05827 15.8724 4.78135 15.4419 3.66742 14.7208C0.848506 12.9193 -0.560742 9.45519 0.208774 6.20102C1.25789 1.7546 5.69637 -0.896969 10.1107 0.281925C13.0735 1.07231 15.3808 3.6087 15.8787 6.62083C15.9267 6.91295 15.9601 7.20506 16.0001 7.49968V8.50122C15.9889 8.54081 15.9802 8.5811 15.9742 8.62182C15.834 10.3745 15.1918 11.9211 14.0384 13.2448C12.7981 14.6678 11.2455 15.5458 9.38037 15.8788C9.08992 15.9289 8.7953 15.9585 8.50277 15.9982ZM1.12685 7.9871C1.11266 11.7783 4.19281 14.8685 7.99616 14.8789C11.7836 14.8894 14.8605 11.8247 14.8817 8.01965C14.9039 4.23133 11.8283 1.13866 8.01952 1.1203C4.22995 1.10194 1.13895 4.18125 1.12685 7.9871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82134 9.16932C8.82134 9.80405 8.81508 10.4388 8.82467 11.0731C8.8276 11.2884 8.74121 11.4336 8.56344 11.5321C8.39897 11.6291 8.21227 11.6819 8.02138 11.6856C7.8305 11.6892 7.64191 11.6436 7.47385 11.553C7.28439 11.457 7.18716 11.3026 7.18799 11.076C7.19467 9.80099 7.19467 8.52639 7.18799 7.25221C7.18799 7.00182 7.29733 6.84408 7.516 6.75895C7.67327 6.69559 7.84149 6.66382 8.01104 6.66547C8.1806 6.66711 8.34817 6.70214 8.50418 6.76855C8.71284 6.85535 8.8276 7.00475 8.82384 7.25054C8.81466 7.88902 8.82134 8.52917 8.82134 9.16932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01227 5.69687C7.72641 5.69395 7.49773 5.59922 7.3187 5.39682C7.20259 5.27159 7.13888 5.10664 7.14066 4.93587C7.14245 4.76511 7.2096 4.60152 7.3283 4.47875C7.66215 4.11151 8.29896 4.10025 8.64491 4.4583C8.83728 4.65777 8.90864 4.89564 8.81183 5.16063C8.6979 5.47277 8.45461 5.63385 8.13454 5.68894C8.09396 5.6939 8.05314 5.69655 8.01227 5.69687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_5754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9962,
    fill: "white",
    transform: "translate(0 0.00189209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.28efa0bb5cdbcb778f750731405b274a.svg";
export { ForwardRef as ReactComponent };